<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>新品荟统计</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">新品荟统计</div>

                <div style="display:flex;margin-top:15px">
                    <el-input placeholder="请输入搜索的内容" size="small" class="marLeft" style="width: 200px;"
                        v-model="searchField" clearable>
                    </el-input>
                    <el-button type="primary" size="small" @click="searchChick()" class="marLeft">搜索</el-button>
                </div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="hostExcelExportBackChange">
                    <i class="icon iconfont icon-downLoad2"></i>
                    <span>导出</span>
                </div>
            </div>
        </div>
        <div class="header-tabs">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
                <TabPane :label="showTabs == '0' ? '页面浏览数据' + '(' + totalCount + ')' : '页面浏览数据'" name="0">
                </TabPane>
                <TabPane :label="showTabs == '1' ? '产品浏览数据' + '(' + totalCount + ')' : '产品浏览数据'" name="1">
                </TabPane>
                <TabPane :label="showTabs == '2' ? '产品关注数据' + '(' + totalCount + ')' : '产品关注数据'" name="2">
                </TabPane>
            </Tabs>
        </div>

        <div class="" style="margin:20px;">
            <RadioGroup v-model="newsAudit" type="button" @on-change="initStatus">
                <Radio label="0">小程序</Radio>
                <Radio label="1">英文PC</Radio>
            </RadioGroup>
        </div>

        <div class="layout-content" style="background: transparent;">
            <!-- <div v-if="list.length"> -->
            <div v-if="list.length">
                <Table :columns="showTabs == '0' ? columns1 : showTabs == '1' ? columns : columns2" :loading="loading"
                    :data="list">
                    <template slot-scope="{ row }" slot="typeY">{{ row.cname ? row.cname : '全部' }}</template>
                    <template slot-scope="{ row }" slot="name">{{ row.productName }}</template>
                    <template slot-scope="{ row }" slot="type">
                        {{ row.productCategory ? row.productCategory : '' }}
                    </template>
                    <template slot-scope="{ row }" slot="liang">
                        {{ row.countNum }}
                    </template>
                    <template slot-scope="{ row }" slot="isdeal">
                        <div>
                            <span class="lookClass" style="cursor:pointer" @click="rejectP(row, '0')">查看</span>
                        </div>


                    </template>
                </Table>
                <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
                    <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
                        @on-change="changePage" @on-page-size-change="changePageSize" />
                </div>
            </div>
            <div class="u-empty" v-else>暂无数据</div>
        </div>

        <iModal :title="modelTitle" v-model="rejectModel" class-name="vertical-center-modal" width="600px"
            :mask-closable="false">
            <div v-if="showTabs == 0">
                <p>页面类型：{{ rowUser.cname ? rowUser.cname : "全部" }}</p>
                <p>浏览量：{{ rowUser.countNum }}</p>
                <p v-if="newsAudit == 0">浏览人姓名：</p>
                <p v-if="newsAudit == 0">
                    <span v-for="(item1, index1) in tableList" :key="index1" :title="item1.inTime">
                        {{ item1.userName }}
                    </span>
                </p>

                <p v-if="newsAudit == 1">浏览人ip：</p>
                <p v-if="newsAudit == 1">
                    <span v-for="(item1, index1) in tableList" :key="index1">
                        {{ item1.ips }}
                    </span>
                </p>
            </div>
            <div v-else>
                <p>产品名称：{{ rowUser.productName }}</p>
                <p>产品类别：{{ rowUser.productCategory ? rowUser.productCategory : "" }}</p>
                <!-- <p>公司名称：/api/Contact/GetByCompId根据公司id获取</p> -->
                <p>联系人：
                    <span v-for="(item3, index3) in contactsList" :key="index3">
                        {{ item3.name }}
                    </span>
                </p>
                <p>职务：
                    <span v-for="(item6, index6) in contactsList" :key="index6">
                        {{ item6.jobTitle }}
                    </span>
                </p>
                <p>手机：
                    <span v-for="(item5, index5) in contactsList" :key="index5">
                        {{ item5.mob }}
                    </span>
                </p>
                <p>邮箱：
                    <span v-for="(item4, index4) in contactsList" :key="index4">
                        {{ item4.email }}
                    </span>
                </p>
                <p>关注量：{{ rowUser.countNum }}</p>

                <p v-if="newsAudit == 0 && showTabs != '2'">浏览人姓名：</p>
                <p v-if="newsAudit == 0 && showTabs == '2'">浏览人：</p>
                <p v-if="newsAudit == 0">
                    <span v-for="(item2, index2) in tableList" :key="index2">
                        {{ item2.userName }}
                    </span>
                </p>

                <p v-if="newsAudit == 1">浏览人ip：</p>
                <p v-if="newsAudit == 1">
                    <span v-for="(item2, index2) in tableList" :key="index2">
                        {{ item2.ips }}
                    </span>
                </p>
            </div>



            <div slot="footer">
                <Button type="primary" @click="rejectModel = false">确定</Button>
                <!-- <Button type="primary" @click="handleSubmitReject()">确定</Button>
                <Button @click="rejectModel = false">取消</Button> -->

            </div>
        </iModal>
        <div class="catalogue-content"></div>

    </div>
</template>
  
<script>
let moment = require("moment");
import { mapGetters, mapActions } from 'vuex'
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
    name: 'exhibition-info-carApply',
    data () {
        return {
            newsAudit: "0",
            productTypeOptions: [
                {
                    value: '选项1',
                    label: '黄金糕',
                },
            ],
            productTypeValue: '',

            modalDetail: false,
            loading: false,

            editBrand: false,
            editBrandnfo: null,
            editTopic: false,
            editTopicnfo: null,
            search: '',
            editInfo: null,
            pageSize: 20,
            pageIndex: 1,
            totalCount: 0,
            columns: [

                {
                    title: '产品名称',
                    slot: 'name',
                    align: 'center',
                },
                {
                    title: '产品类别',
                    slot: 'type',
                    align: 'center',
                },
                {
                    title: '浏览量',
                    slot: 'liang',
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'isdeal',
                    align: 'center',
                },
            ],
            columns2: [

                {
                    title: '产品名称',
                    slot: 'name',
                    align: 'center',
                },
                {
                    title: '产品类别',
                    slot: 'type',
                    align: 'center',
                },
                {
                    title: '关注量',
                    slot: 'liang',
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'isdeal',
                    align: 'center',
                },
            ],
            columns1: [
                {
                    title: '页面类别',
                    slot: 'typeY',
                    align: 'center',
                },
                {
                    title: '浏览量',
                    slot: 'liang',
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'isdeal',
                    align: 'center',
                },
            ],
            oppTime: [],
            searchField: '',
            list: [],
            selection: [], // 选中项目
            addShow: false,
            rejectModel: false,
            modelTitle: '',
            rowUser: {},
            showTabs: '0',
            PoptipTitle: '',
            option: {},
            stateInit: '',
            rejectValue: '',
            form: {
                category: [], // 展品分类
            },
            type: [],
            contactsList: [],
            tableList: [],
            idCategory: '',
            proIdType: "fcb459d0-9565-413b-832d-f25bba4c3567",
            statusProType: ['wait'],
            excelOpt: {},
        }
    },
    components: {
        // exhibitionCarYes,
        // exhibitionCarNo
    },
    computed: {
        ...mapGetters({
            exhibition: 'loginModule/getExhibition',
            exhibitionInfo: 'hostSetModule/getHostExhibition',
            hostExhibition: 'hostSetModule/getHostExhibition',

        }),
    },
    created () {
        document.title = '中国国际医疗器械博览会 - 产品审核'
        this.initProType()
        this.init()
    },
    methods: {
        ...mapActions({
            getHostBuySupply: 'hostSetModule/getHostBuySupply',
            putHostUpdateState: 'hostSetModule/putHostUpdateState',
            getHostCallingAgain: 'hostSetModule/getHostCallingAgain',
            getBuyExport: 'hostSetModule/getBuyExport',
            //   商机
            busOppNewRealeaseGetPageList:
                'hostSetModule/busOppNewRealeaseGetPageList',
            getProductByGroupId: 'categoryModule/getProductByGroupId', // 获取  产品类别
            busOppNewRealeasePutUpdate: 'hostSetModule/busOppNewRealeasePutUpdate', // 修改
            busOppNewRealeaseExcelExportHost:
                'hostSetModule/busOppNewRealeaseExcelExportHost',
            newRealeaseSetIsShow: 'hostSetModule/newRealeaseSetIsShow',
            getByCompId: 'hostSetModule/getByCompId',
            getAllBindsById: 'hostSetModule/getAllBindsById',

            getAuditLogPass: 'hostSetModule/getAuditLogPass',
            getAuditLogPut: 'hostSetModule/getAuditLogPut',
            postProductTagCount: 'hostSetModule/postProductTagCount',

            postExcelExportTagCount: 'hostSetModule/postExcelExportTagCount',
            postExcelExportWechatProduct: 'hostSetModule/postExcelExportWechatProduct',



            postProductTagAuditLogPage: 'hostSetModule/postProductTagAuditLogPage',
        }),
        switchBrand (name) {
            this.pageIndex = 1
            this.init()
        },

        initStatus () {
            this.pageIndex = 1
            if (this.newsAudit == 0) {
                this.statusProType = ['wait']
            }
            if (this.newsAudit == 1) {
                this.statusProType = ['pass', 'notpass']
            }
            this.init()

        },
        searchChick () {
            this.init()
            //     this.startDateStr = this.formatDate(this.oppTime[0])
            //   this.endDateStr = this.formatDate(this.oppTime[1])
        },
        // 转换日期格式
        formatDate (dateTime) {
            let date = new Date(dateTime)
            let YY = date.getFullYear() + '-'
            let MM =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '-'
            let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            let hh =
                (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            let mm =
                (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                ':'
            let ss =
                date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            //    return YY + MM + DD + " " + hh + mm + ss;
            return YY + MM + DD
        },

        async init () {

            let a = [
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 6,
                        Label: 'Cname',
                        Value: `%${this.searchField || ''}%`,
                    },
                },
            ]

            let pushList = this.searchField ? a : {}

            let pushList1 = [
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 6,
                        Label: 'ProductCategory',
                        Value: `%${this.searchField || ''}%`,
                    },
                },
            ]


            this.option = {
                tagId: this.proIdType,
                dataType: this.showTabs == '0' ? 'page' : 'product',
                countType: this.showTabs == '2' ? 'follow' : 'preview',
                pageType: this.newsAudit == '0' ? 'wechat' : 'pcen',
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
                // Wheres: {}
                Wheres: {
                    type: 0,
                    Wheres: {
                        WhereGroupOperator: 0,
                        Predicates: this.showTabs == 0 ? pushList : pushList1,
                    },
                },
            }
            console.log(this.option, 'pppppppp')

            this.excelOpt = this.option

            this.loading = true
            let proData = await this.postProductTagCount(this.option)
            if (proData) {
                this.loading = false
                // this.list = proData.items
                let resList = proData.items
                this.pageSize = proData.pageSize
                this.pageIndex = proData.pageIndex
                this.totalCount = proData.totalCount
                resList.forEach((e) => {
                    if (e.productCategory) {
                        const category = JSON.parse(e.productCategory)
                        const categoryArr = []
                        if (category) {
                            if (category.Value) {
                                categoryArr.push(category.Value)
                                if (category.List[0]) {
                                    categoryArr.push(category.List[0].Value)
                                    if (category.List[0].list) {
                                        categoryArr.push(category.List[0].list[0].Value)
                                    }
                                }

                                e.productCategory = categoryArr.join('/')
                            }
                        }
                    }
                })
                this.list = resList
                console.log(this.list, '[][][][][][][][]')
            } else {
                this.loading = false
            }
        },

        // 查询产品类别
        async initProType () {
            let categoryData = await this.getProductByGroupId({
                groupId: this.hostExhibition.groupId,
                level: 0,
                loadChild: true,
            }) // 暂时先写死了值
            if (categoryData && categoryData.length) {
                categoryData.map((c) => {
                    c.value = c.name
                    c.label = c.name
                    c.children = JSON.parse(JSON.stringify(c.list))
                    c.children.map((v) => {
                        v.value = v.name
                        v.label = v.name
                        v.children = JSON.parse(JSON.stringify(v.list))
                        v.children.map((z) => {
                            z.value = z.name
                            z.label = z.name
                            z.children = JSON.parse(JSON.stringify(z.list))
                        })
                    })
                })
                this.type = categoryData
                console.log(this.type, '888888888')
            } else {
                this.type = []
            }
        },

        async setAllAudit () {
            const reqList = []
            if (!this.selection.length) return
            this.selection.forEach((c) => {
                reqList.push(c.joinId)
            })
            const bool = await this.setOneStepAudit({
                joinIds: reqList,
            })
            if (bool && bool.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
        },
        changePage (e) {
            this.pageIndex = e
            this.init()
        },
        changePageSize (e) {
            this.pageSize = e
            this.init()
        },
        edit (item) {
            this.editInfo = item
        },
        searchPro () {
            this.pageIndex = 1
            this.init()
        },
        changeEvent (selection) {
            this.selection = selection
        },
        async rejectP (row, index) {

            if (this.showTabs == '2' || this.showTabs == '1') {
                if (this.newsAudit == '0') {
                    this.$router.push(`/host/index/set/zhenXinDetail?data=${JSON.stringify(row)}&type=1`);
                    return
                }
            }


            if (this.showTabs != 0) {
                this.contactsList = await this.getByCompId(row.compId)
                console.log(this.contactsList, '所有联系人');
            }
            let arr = await this.getAllBindsById(row.id)
            arr.map(c => {
                c.inTime = moment(c.inTime).format("YYYY-MM-DD HH:mm:ss");
            });
            this.tableList = arr;
            console.log(this.tableList, 'ip和关注人');



            // getByCompId
            this.rejectValue = ''
            this.rowUser = row
            this.modelTitle = '详情：'
            this.rejectModel = true
            //   }
        },

        // 驳回确定按钮
        async handleSubmitReject () {
            if (!this.rejectValue) {
                this.$Message.warning('驳回理由不能为空！')
                return
            }
            const option = {
                // id: this.rowUser.id,
                id: this.rowUser.id,
                setValues: {
                    Remark: this.rejectValue,
                    AuditStatus: 'notpass',
                },
            }
            let bool = await this.getAuditLogPut(option)
            if (bool && bool.successed) {
                this.rejectModel = false
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
            //   }
        },

        // 获取产品类别
        changeCategory (val) {
            let category = this.form.category
            if (val) {
                category = this.form.category = val
            }
            let data = null
            this.type.forEach((c) => {
                if (category[0] && c.name === category[0]) {
                    this.idCategory = c.id
                    data = {
                        Id: c.id,
                        Value: c.name,
                        List: [],
                    }
                    if (c.list && c.list.length && category[1]) {
                        c.list.forEach((v) => {
                            if (v.name === category[1]) {
                                this.idCategory = v.id
                                data.List[0] = {
                                    Id: v.id,
                                    Value: v.name,
                                }
                                if (v.list && v.list.length && category[2]) {
                                    v.list.forEach((j) => {
                                        if (j.name === category[2]) {
                                            this.idCategory = j.id
                                            data.List[0].list = [
                                                {
                                                    Id: j.id,
                                                    Value: j.name,
                                                    Remark: j.tag,
                                                },
                                            ]
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
            console.log(this.idCategory)
            return data
        },

        // 修改展品显示、屏蔽
        async showToggle (item) {
            const bool = !!item.isShow
            let result = await this.newRealeaseSetIsShow({
                id: item.id,
                setValues: {
                    IsShow: bool,
                },
            })
            if (result.successed) {
                this.$Message.success('修改成功')
                this.init()
            } else {
                this.$Message.error('修改失败，请重新尝试')
            }
        },

        hostExcelExportBackChange () {
            if (this.showTabs == '2' || this.showTabs == '1') {
                if (this.newsAudit == '0') {
                    this.hostExcelExportBackWechat()
                    return
                }
            } else {
                this.hostExcelExportBack()
            }
        },

        // 展商导出
        async hostExcelExportBack () {

            let res = await this.postExcelExportTagCount(this.excelOpt)
            let filename = "新品荟统计导出.xlsx";
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");

        },
        async hostExcelExportBackWechat () {

            let res = await this.postExcelExportWechatProduct(this.excelOpt)
            let filename = "新品荟统计导出.xlsx";
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");

        },
    },
}
</script>
  
<style scoped lang="scss">
.catalogue {
    .header-tool {
        min-height: 90px;
    }

    &-content {
        min-width: 1000px;
        margin: 24px;
        padding: 40px;
        min-height: 500px;
        padding-bottom: 190px;
    }
}

.cib {
    min-width: 1000px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
}

.spanClass {
    margin-left: 4px;
    margin-right: 4px;
}

.deleteClass {
    color: #f78989;
    // cursor:pointer;
}

.lookClass {
    color: #1890ff;
    cursor: pointer;
}

.marLeft {
    margin-left: 15px;
}
</style>
  